﻿import { api } from '@cwd/lib/main';
import { AccountSetting } from '@shared/Root/Context.access';

export interface AccountSettingDefinition {
    Key: string;
    Type: 'Bool' | 'Int' | 'String';
    Group: string;
    DefaultValue: string;
    Feature: string;
    AccountSetting: AccountSetting;
}

export async function get(): Promise<AccountSettingDefinition[]> {
    return api.get('/AccountSettings/');
}

export async function set(settings: AccountSetting[]): Promise<AccountSettingDefinition[]> {
    return api.post('/AccountSettings/', settings);
}
